import React, {Component} from 'react';
import {connect} from 'react-redux';
import Editor from "../../components/Editor/editor";
import {changeEditorState, createEditor, getEditor, updateEditor} from "../../actions/editor";
import {toJS} from "../../components/General/toJs";

class EditorHOC extends Component {

    componentDidMount(){
        if(this.props.match.params.id){
            this.props.getEditor({personId: this.props.match.params.id})
        }
    }

    submitForm = (formIM) => {
        const form = formIM.toJS();

        if(this.props.match.params.id){
            this.props.updateEditor({
                sendBody: {
                    username: form.username,
                    email: form.email
                },
                personId: this.props.editor.personId
            });
        } else {
            this.props.createEditor({sendBody: {
                    ...form,
                    brandId: this.props.brandId
            }});
        }
    };

    getInitialValues = () => {
        if(!this.props.editor.id) {
            return null;
        }

        return {
            username: this.props.editor.person.username,
            email: this.props.editor.person.email
        }
    };

    render(){
        return (
            <Editor
                {...this.props}
                submitForm={this.submitForm}
                getInitialValues={this.getInitialValues}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        brandId: state.login.getIn(['userInfo', 'brand', 'id']),
        editor: state.editor.get('editor'),
        errorMessage: state.editor.get('errorMessage'),
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        createEditor: (payload) => {
            dispatch(createEditor(payload))
        },
        changeEditorState: (payload) => {
            dispatch(changeEditorState(payload))
        },
        getEditor: (payload) => {
            dispatch(getEditor(payload))
        },
        updateEditor: (payload) => {
            dispatch(updateEditor(payload))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(EditorHOC));


// WEBPACK FOOTER //
// ./src/containers/Editor/editorHOC.js